module.exports = __webpack_public_path__ + "assets/img/gk-banner.625b7d0e.png";